import { createFileRoute } from "@tanstack/react-router";
import HowEffectiveIsSpravatoPage from "@/pages/articles/HowEffectiveIsSpravatoPage";
export const Route = createFileRoute("/how-effective-is-spravato")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How Effective Is SPRAVATO®? | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn about the clinical efficacy, rapid onset, and response rates of SPRAVATO® esketamine nasal spray for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "How Effective Is SPRAVATO®? | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn about the clinical efficacy, rapid onset, and response rates of SPRAVATO® esketamine nasal spray for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/how-effective-is-spravato",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-effective-is-spravato",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowEffectiveIsSpravatoPage />;
}
